var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GoBackToSalesServicePoint"},[_c('BrandButton',{attrs:{"type":"primary","colors":_vm.buttonColors},on:{"click":_vm.redirectToSalesServicePoint}},[_vm._v("\n    "+_vm._s(_vm.$t('buttons.back_to_store'))+"\n    "+_vm._s(_vm.secondsToAutoRedirect)+" s.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-758d2826","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AfterPaymentPage/GoBackToSalesServicePoint/index.vue
// module id = 392
// module chunks = 1